import OTPInput from "react-otp-input";
import styles from './inputotp.module.css';

export default function InputOTP({ OTPValue, setOTPValue }) {
  return (
    <OTPInput
      value={OTPValue}
      onChange={setOTPValue}
      numInputs={6}
      renderSeparator={<span>-</span>}
      renderInput={(props) => <input {...props} />}
      inputType={"tel"}
      inputStyle={styles.inputOTP}
    />
  );
}